import Slideout from "slideout";

if (!$('body').hasClass('dashboard')) {
    var slideout = new Slideout({
        'panel': document.getElementById('panel'),
        'menu': document.getElementById('menu'),
        'padding': 320,
        'tolerance': 70,
        'side': 'right',
        'touch': false
    });

    // Toggle button
    document.querySelector('.toggle-button').addEventListener('click', function() {
        slideout.toggle();
        $('.toggle-button').toggleClass('is-active');
    });

    document.querySelector('.toggle-button-mobile').addEventListener('click', function() {
        slideout.close();
        $('.toggle-button').removeClass('is-active');
    });
}
